import { useMutation } from "react-query";
import http from "infra/http";
import { ParticipanteForm } from "../typings";

function useSaveAssembleiaParticipante(votacaoId?: string) {
  return useMutation(
    "/v1/votacao/id/participante",
    (data: ParticipanteForm) =>
      http.post(`/v1/votacao/${votacaoId}/participante`, data),
    { retry: false }
  );
}

export default useSaveAssembleiaParticipante;
